import libraries from './content/reducers'
import libraryElements from './content/items/reducers'
import contentItem from './content/items/details/reducers'

export default {
  libraries,
  libraryElements,
  contentItem,
}
